import { AnimatedSection, GlowCard, GlassGlow, NoiseTexture } from "../shared";
import {
  IconYield,
  IconArbitrage,
  IconSocial,
  IconPortfolio,
  IconAlert,
  IconSniper,
} from "../shared/icons";
import { AGENTS } from "./constants";

const ICON_MAP: Record<string, JSX.Element> = {
  yield: <IconYield />,
  arbitrage: <IconArbitrage />,
  social: <IconSocial />,
  portfolio: <IconPortfolio />,
  alert: <IconAlert />,
  sniper: <IconSniper />,
};

export function AgentLibrary() {
  return (
    <section id="agents" className="py-12 md:py-16 px-6 relative overflow-hidden">
      <NoiseTexture />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0a] via-[#0c0c0c] to-[#0a0a0a]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_50%_30%_at_50%_0%,_rgba(100,100,200,0.04),_transparent)]" />

      <div className="max-w-7xl mx-auto w-full relative z-10">
        <AnimatedSection>
          <div className="mb-12">
            <span className="inline-flex items-center gap-2.5 text-[11px] font-semibold tracking-[0.2em] uppercase text-white/35 mb-5 before:content-[''] before:w-5 before:h-px before:bg-gradient-to-r before:from-violet-500/60 before:to-transparent">
              Agent Library
            </span>
            <h2 className="font-space-grotesk text-4xl md:text-6xl font-bold tracking-[-0.03em] gradient-text-dark">
              Plug-and-play AI agents
            </h2>
            <p className="text-lg text-white/55 mt-5 max-w-2xl">
              For every crypto strategy. Activate in one click.
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {AGENTS.map((agent, i) => (
            <AnimatedSection key={agent.title} delay={i * 0.08}>
              <GlowCard className={`h-full border p-8 rounded-2xl transition-all duration-500 group cursor-pointer ${
                agent.featured
                  ? "bg-gradient-to-b from-[#151518] to-[#111] border-white/[0.08] hover:border-white/[0.15]"
                  : "bg-[#111] border-white/[0.06] hover:border-white/[0.1]"
              }`}>
                <GlassGlow intensity={agent.featured ? 0.1 : 0.06} size={55} />
                <NoiseTexture />
                <div className="relative z-10 flex flex-col h-full">
                  <div className="mb-5 w-8 h-8 flex items-center justify-center text-white/30 group-hover:text-white/60 transition-colors duration-400">
                    {ICON_MAP[agent.iconKey]}
                  </div>
                  <h3 className="font-space-grotesk text-lg font-bold mb-2.5">{agent.title}</h3>
                  <p className="text-white/55 text-sm leading-relaxed mb-6">{agent.desc}</p>
                  <div className="mt-auto flex items-center">
                    {agent.avatars ? (
                      agent.avatars.map((url, ci) => (
                        <img
                          key={ci}
                          src={url}
                          alt=""
                          className="w-6 h-6 rounded-full border border-white/10 object-cover bg-white/5"
                          style={{ marginLeft: ci > 0 ? -4 : 0 }}
                        />
                      ))
                    ) : (
                      agent.coins?.map((coin, ci) => (
                        <img
                          key={ci}
                          src={`${process.env.PUBLIC_URL}/coins/${coin}`}
                          alt=""
                          className="w-6 h-6 rounded-full border border-white/10 object-cover bg-white/5"
                          style={{ marginLeft: ci > 0 ? -4 : 0 }}
                        />
                      ))
                    )}
                    {agent.more && (
                      <span className="text-[11px] text-white/30 font-medium ml-2.5 border border-white/[0.08] rounded-full px-2.5 py-0.5">{agent.more}</span>
                    )}
                  </div>
                </div>
              </GlowCard>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AgentLibrary;
